module.exports = __webpack_public_path__ + "img/shiba-loading.0c6df096.png";